import { Skeleton } from '@nextui-org/react';

const SkeletonTotalLock = () => {
  const arr = Array.from(Array(3).keys());

  return (
    <div className="flex flex-col gap-[20px]">
      {arr.map((item) => (
        <Skeleton key={item} className="h-[150px] w-full rounded-[18px] bg-gray-50" />
      ))}
    </div>
  );
};

export default SkeletonTotalLock;
